import { gql } from "@apollo/client";

export const GET_FAVS = gql`
  query getFavs($offset: String) {
    User {
      getFavs(offset: $offset) {
        listings {
          id
          title
          price
          content
          published
          imgs
          refresh
          category
          beds
          livings
          wc
          area
          type
          street_width
          age
          last_update
          street_direction
          ketchen
          ac
          furnished
          location {
            lat
            lng
          }
          user {
            review
            img
            name
            phone
            iam_verified
          }
          district
        }
        offset
      }
    }
  }
`;

export const GET_FAV_IDS = gql`
  query getFavIDs {
    User {
      getFavIDs
    }
  }
`;
